import { Box } from "@mui/system";
import ConversionsTable from "./ConversionsContent/ConversionsTable";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../../../../../features/userSlice";
import { useEffect, useState } from "react";
import { buiDashboardEndPointLogicMobile } from "../../../../../../../../logic/AssetManagement/overview/BusinessLeaderDashboardMobile/buiDashboardEndPointLogicMobile";
import { lastTwoWeeksQueryIdConversion } from "../../../helpers/QIDs";
import { setConversionFetchedForWorkspace } from "../../../../../../../../features/businessLeaderDashboardSlice";
import ConversionSkeleton from "./ConversionsContent/ConversionSkeleton";

const Conversions = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const websiteSharedUids = searchParams.get("workspace");
  const [loading, setLoading] = useState(false);
  const {
    conversionFetchedForWorkspace,
  } = useSelector((state: any) => state.businessLeaderDashBoard);

  useEffect(() => {
    if (!oauthTokenHeader || !websiteSharedUids) return;
    if (conversionFetchedForWorkspace === websiteSharedUids) return;
    const fetchData = async () => {
      try {
        setLoading(true);
        const dimensionResponse =
          await buiDashboardEndPointLogicMobile.getDimensionInBizLeaderDashboardMobile(
            oauthTokenHeader,
          );
        if (!dimensionResponse || dimensionResponse.status !== 200) {
          return;
        }
        const dimensions = dimensionResponse?.data?.data || [];
        const matchedDimensions = dimensions
          ?.filter((dim: any) =>
            dim.websites?.some(
              (site: any) => site.shared_uid === websiteSharedUids,
            ),
          )
          ?.map((dim: any) => dim.dimension);
        if (!matchedDimensions?.length) return;
        await buiDashboardEndPointLogicMobile.getConversionLastTwoWeeksQueryInBizLeaderDashboardMobile(
          {
            oauthTokenHeader,
            queryId: lastTwoWeeksQueryIdConversion,
            websiteSharedUids: websiteSharedUids?.split(",") || [],
            type: "site",
            dimension: matchedDimensions || [],
          },
        );
        dispatch(setConversionFetchedForWorkspace(websiteSharedUids));
      } catch (e: any) {
        dispatch(
          setDisplayErrorSnackBar({
            message:
              e?.parsedText ||
              "Failed to fetch last two weeks query data. Please try again later or Refresh the page.",
            type: "error",
          }),
        );
      } finally {
        setLoading(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, websiteSharedUids, conversionFetchedForWorkspace]);

  return (
    <>
      <Box sx={{ px: 2 }}>
        {loading ? (
          <ConversionSkeleton />
        ) : (
          <ConversionsTable />
        )}
      </Box>
    </>
  );
};

export default Conversions;
